import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OpportunityNotFound = ({ title, }) => {
    return (_jsxs("div", Object.assign({ className: "opportunity-not-found" }, { children: [_jsx("h3", { children: "We didn't find match for your search." }), _jsxs("h3", { children: ["Here are some of our latest in ", title, " category."] })] })));
};
export default OpportunityNotFound;
